import type { SiteSettings } from '@/lib/api';

export type EmojiPack = { id: string; name: string; emojis: string[] };

// Комментарий на русском: дефолтные реакции, если packs/настройки не загрузились.
export const DEFAULT_MESSENGER_REACTIONS = ['👍', '❤️', '😂', '😮', '😢', '😡', '🔥', '👏', '🙏', '🎉'] as const;

let _packsCache: EmojiPack[] | null = null;
let _packsInflight: Promise<EmojiPack[]> | null = null;

export async function fetchEmojiPacks(): Promise<EmojiPack[]> {
  if (_packsCache) return _packsCache;
  if (_packsInflight) return _packsInflight;

  _packsInflight = fetch('/emoji-packs/_list', { cache: 'no-store' })
    .then((r) => (r.ok ? r.json() : []))
    .then((data) => (Array.isArray(data) ? (data as EmojiPack[]) : []))
    .then((packs) => {
      _packsCache = packs;
      return packs;
    })
    .catch(() => {
      _packsCache = [];
      return [];
    })
    .finally(() => {
      _packsInflight = null;
    });

  return _packsInflight;
}

function uniq(xs: string[]): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const x of xs) {
    const v = String(x || '').trim();
    if (!v || seen.has(v)) continue;
    seen.add(v);
    out.push(v);
  }
  return out;
}

export function buildMessengerReactionsFromSettings(packs: EmojiPack[], settings: SiteSettings | null): string[] {
  const map = new Map(packs.map((p) => [p.id, p]));

  const systemId = String((settings as any)?.messenger_system_emoji_pack_id || 'default').trim() || 'default';
  const selected = Array.isArray((settings as any)?.messenger_emoji_pack_ids)
    ? ((settings as any).messenger_emoji_pack_ids as any[]).map((x) => String(x || '').trim()).filter(Boolean)
    : ['default'];

  const system = map.get(systemId)?.emojis || [];
  const extras: string[] = [];
  for (const id of selected) {
    const p = map.get(id);
    if (!p) continue;
    extras.push(...(p.emojis || []));
  }

  const merged = uniq([...(system || []), ...extras]);
  const limited = merged.slice(0, 80);
  return limited.length ? limited : [...DEFAULT_MESSENGER_REACTIONS];
}

